import { restApiMP } from "@plannel/services/utils/rest-api";

const getOrderTrackingResult = params => {
    return restApiMP.get("/api/mp-order-tracking", { params });
};

const getTestOrderTrackingResult = params => {
    return restApiMP.get("/test-data/order-tracking.json", { params });
};

const getOrdertrackingDetail = params => {
    return restApiMP.get("/test-data/order-tracking-detail.json", { params });
}

// const getAllForCSV = params => {
//   return restApiMP.get("/api/mrp-report/csv", { params });
// };

const orderTrackingService = {
    getOrderTrackingResult,
    getTestOrderTrackingResult,
    getOrdertrackingDetail,
    restApiMP
};

export default orderTrackingService;